<template>
  <div class="container-fluid h-100">
    <div class="row text-center">
      <div class="col-12 bg-blue-200 py-3">
        <div class="container">
          <div class="row">
            <div class="col-12 d-flex flex-column py-5">
              <div class="mt-auto">
                <h1 class="h3">
                  Les documents contractuels ont bien été signés.
                </h1>
              </div>
              <div class="mb-auto">
                Nous vous remercions d'avoir choisi <span class="text-primary">Assurup !</span>
              </div>
            </div>
          </div>
          <div
            v-if="isOdr"
            class="col-8 col-md-10 mx-auto"
          >
            <div class="card">
              <div
                class="card-body py-md-4 pt-4 rounded-4 transition-shadow
            box-shadow-pink-300 box-shadow-hover-pink-300"
              >
                <div class="col-12 col-md-10 mx-auto">
                  <h1>Envoyer mon ordre de remplacement</h1>
                  <span>J'autorise Assurup à envoyer mon Ordre de remplacement directement
                    à mon courtier / assureur</span>
                  <div class="row mt-2">
                    <div class="col-12">
                      <v-input
                        label="Mettre en copie"
                        placeholder="nicolas.moreau@gmail.com"
                        value="email"
                        action-module="documents"
                        path="message.cc"
                        :validation="validateEmail"
                      />
                    </div>
                    <div class="col-12 mt-2">
                      <v-textarea
                        input-id="odr-comment"
                        label="Commentaire"
                        placeholder="Commentaire..."
                        module-name="documents"
                        getter-name="message.comment"
                        rows="5"
                        path="message.comment"
                      />
                    </div>
                    <div class="col-12 mt-3">
                      <v-loader
                        :next="send"
                        :disable-button="isButtonDisabled"
                        title="Envoyer"
                        class="my-3 w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isOdr"
      class="container"
    >
      <div class="row mt-3">
        <div
          class="col-12 text-center mb-4"
          style="margin-top: -2em"
        >
          <img
            :src="aws + '/unicorn-feather.png'"
            width="250"
            class="img-fluid"
          >
        </div>
        <div class="col-12 col-md-8 d-flex mx-auto">
          <v-loader
            :next="closeWin"
            title="Retour à l'espace de gestion"
            color="primary"
            icon="arrow-white-right"
            class="d-flex mx-auto"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSignatureFromId } from '@/services/api/document/document';
import { routing, ui } from '@/mixins';
import Loader from '@/components/common/helpers/Loader.vue';
import { validateEmail } from '@/utils/validators';
import { Input } from '@/components/common/input';
import Textarea from '@/components/common/input/Textarea.vue';

export default {
  name: 'SignatureView',
  components: {
    'v-input': Input,
    'v-loader': Loader,
    'v-textarea': Textarea,
  },
  mixins: [routing, ui],
  data() {
    return {
      validateEmail,
      isOdr: false,
    };
  },
  computed: {
    message() {
      return this.$store.getters['documents/message'];
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    isButtonDisabled() {
      if (this.message.cc) {
        return !this.validateEmail(this.message.cc);
      }
      return false;
    },
  },
  mounted() {
    const { requestId } = this.$route.query;
    if (requestId) {
      getSignatureFromId(requestId).then((response) => {
        if (response && response.data) {
          const doc = response.data;
          this.isOdr = doc.contractDocuments[0].template.documentType === 'ODR';
        }
      });
    }
  },
  methods: {
    async send() {
      try {
        const { requestId } = this.$route.query;
        await this.$store.dispatch('documents/send', requestId);
        this.ui_showToast({ show: true, message: 'Votre ordre de remplacement a bien été envoyé à votre assureur.' });
        this.closeWin();
        window.location.assign('/client?from=signature');
      } catch (err) {
        this.error = 'Erreur, veuillez réessayer ultérieurement.';
        Promise.reject();
      }
    },

    async closeWin() {
      try {
        const iframe = window.parent.document
          .getElementById('signature')
          .contentWindow
          .parent;
        iframe.postMessage('Hello there, general Kenobi', iframe.source);
        return Promise.resolve();
      } catch (err) {
        this.$store.dispatch('reporting/sendError', { err, currentPage: 'signatureCallback' });
        return Promise.reject();
      }
    },
  },
};
</script>
